import {takeEvery} from 'redux-saga/effects'
import {
  PARENTING_ATTEMPT_CLASS,
  PARENTING_CREATE_EXPERT_OPINION,
  PARENTING_GET_ARTICLE,
  PARENTING_GET_BLOG_POST,
  PARENTING_GET_BLOG_POSTS,
  PARENTING_GET_CLASS,
  PARENTING_GET_CLASSES,
  PARENTING_GET_CLASS_QUIZ,
  PARENTING_GET_CUSTOM_MESSAGE,
  PARENTING_GET_DASHBOARD,
  PARENTING_GET_EXPERT_OPINION_FORM,
  PARENTING_GET_NOTIFICATIONS,
  PARENTING_GET_TESTIMONIALS,
  PARENTING_GET_TIP,
  PARENTING_GET_TIPS,
  PARENTING_GET_TODAYS_TIP,
  PARENTING_GET_WEEKLY_ARTICLE,
  PARENTING_LIKE_TIP,
  PARENTING_POST_BLOG_COMMENT,
  PARENTING_SAVE_QUIZ_ANSWER,
} from 'setup/redux/Actions/Parenting/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

/** Routes every parenting-section request through the shared fetch worker. */
function* parentingSagas() {
  yield takeEvery(PARENTING_GET_DASHBOARD, fetchData)
  yield takeEvery(PARENTING_GET_TODAYS_TIP, fetchData)
  yield takeEvery(PARENTING_GET_TIPS, fetchData)
  yield takeEvery(PARENTING_GET_TIP, fetchData)
  yield takeEvery(PARENTING_LIKE_TIP, fetchData)
  yield takeEvery(PARENTING_GET_WEEKLY_ARTICLE, fetchData)
  yield takeEvery(PARENTING_GET_ARTICLE, fetchData)
  yield takeEvery(PARENTING_GET_CLASSES, fetchData)
  yield takeEvery(PARENTING_ATTEMPT_CLASS, fetchData)
  yield takeEvery(PARENTING_GET_CLASS_QUIZ, fetchData)
  yield takeEvery(PARENTING_SAVE_QUIZ_ANSWER, fetchData)
  yield takeEvery(PARENTING_GET_CLASS, fetchData)
  yield takeEvery(PARENTING_GET_TESTIMONIALS, fetchData)
  yield takeEvery(PARENTING_GET_BLOG_POSTS, fetchData)
  yield takeEvery(PARENTING_GET_BLOG_POST, fetchData)
  yield takeEvery(PARENTING_POST_BLOG_COMMENT, fetchData)
  yield takeEvery(PARENTING_GET_NOTIFICATIONS, fetchData)
  yield takeEvery(PARENTING_GET_CUSTOM_MESSAGE, fetchData)
  yield takeEvery(PARENTING_GET_EXPERT_OPINION_FORM, fetchData)
  yield takeEvery(PARENTING_CREATE_EXPERT_OPINION, fetchData)
}

export default parentingSagas
